import {API, instance} from "../const/api";


export async function UploadImage(foramData, Calback) {

    await instance.post(API.uploadImage, foramData, {
        headers: {
            'content-type': 'application/json',
        },
    })
        .then(function (response) {
            Calback(response)
        })
        .catch(function (error) {
            Calback(error.response);
        });
}


export async function MediaRemove(id, Calback) {

    await instance.post(API.mediaremove + "/" + id, {}, {
        headers: {
            'content-type': 'application/json',
        },
    })
        .then(function (response) {
            Calback(response)
        })
        .catch(function (error) {
            Calback(error.response);
        });
}


export async function UpdateUser(formData, Calback,ProgressEvent) {

    await instance.post(API.User, formData,{
        headers: {
            'content-type': 'application/json',
        },
        onUploadProgress: progressEvent => ProgressEvent(progressEvent),
    })
        .then(function (response) {
            Calback(response)
        })
        .catch(function (error) {
            Calback(error.response);
        });
}



export async function GetUser( param,Calback) {
    await instance.get(API.User,{
            params:param,
            headers: {
                'content-type': 'application/json',
            },
        }
    )
        .then(function (response) {
            Calback(response)
        })
        .catch(function (error) {
            Calback(error.response);
        });
}


export async function DeleteUser(id, Calback) {

    await instance.delete(API.User + "/" + id, {}, {
        headers: {
            'content-type': 'application/json',
        },
    })
        .then(function (response) {
            Calback(response)
        })
        .catch(function (error) {
            Calback(error.response);
        });
}


export async function DeleteBook( id,Calback) {
    await instance.delete(API.BookList+"/"+id,{
            headers: {
                'content-type': 'application/json',
            },
        }
    )
        .then(function (response) {
            Calback(response)
        })
        .catch(function (error) {
            Calback(error.response);
        });
}


export async function GetEmployee( param,Calback) {
    await instance.get(API.Employee,{
            params:param,
            headers: {
                'content-type': 'application/json',
            },
        }
    )
        .then(function (response) {
            Calback(response)
        })
        .catch(function (error) {
            Calback(error.response);
        });
}

export async function GetEmployeeAttendance( param,Calback) {
    await instance.get(API.EmployeeAttendance,{
            params:param,
            headers: {
                'content-type': 'application/json',
            },
        }
    )
        .then(function (response) {
            Calback(response)
        })
        .catch(function (error) {
            Calback(error.response);
        });
}



export async function GetNPC( param,Calback) {
    await instance.get(API.NCP,{
            params:param,
            headers: {
                'content-type': 'application/json',
            },
        }
    )
        .then(function (response) {
            Calback(response)
        })
        .catch(function (error) {
            Calback(error.response);
        });
}


export async function GetNG( param,Calback) {
    await instance.get(API.NG,{
            params:param,
            headers: {
                'content-type': 'application/json',
            },
        }
    )
        .then(function (response) {
            Calback(response)
        })
        .catch(function (error) {
            Calback(error.response);
        });
}


export async function GetLead( param,Calback) {
    await instance.get(API.Lead,{
            params:param,
            headers: {
                'content-type': 'application/json',
            },
        }
    )
        .then(function (response) {
            Calback(response)
        })
        .catch(function (error) {
            Calback(error.response);
        });
}